var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.968,
    height: 21,
    viewBox: "0 0 20.968 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 332",
    transform: "translate(-743 -1043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0,0,10.5l2.467,2.467L10.5,4.952l8.033,8.015L21,10.5Z",
    transform: "translate(755.967 1043) rotate(90)",
    fill: "#D93025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0,0,10.5l2.467,2.467L10.5,4.952l8.033,8.015L21,10.5Z",
    transform: "translate(751 1064) rotate(-90)",
    fill: "#D93025"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDelete);
export default __webpack_public_path__ + "static/media/close-delete.acd6bf516aea5f30614fc34345646303.svg";
export { ForwardRef as ReactComponent };